import React, { Component } from 'react'
import { Label } from 'reactstrap'
import { Asterisk } from 'react-bootstrap-icons';

export class LabelBold extends Component {
  render() {

    let {
      required,
    } = this.props;

    return (
      <Label className="d-flex" style={{fontWeight: 500}} {...this.props}>{this.props.children}{required && (<span className='text-danger d-flex align-start mt-2' style={{marginLeft: '0.2em'}}><Asterisk size={8}/></span>)}</Label>
    )
  }
}

export default LabelBold